module.exports = __webpack_public_path__ + "img/mg2.7aab0e0a.jpg";